import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'

export const TitlePanelSetting = ({ label, isShowSub = true }) => {
  if (!label) return <></>

  if (typeof label === 'object') {
    return (
      <>
        <Translate value={label.text} />
        &nbsp;
        {isShowSub && (
          <Element
            elementName="span"
            style={{
              fontStyle: 'italic',
              fontWeight: 400,
              paddingLeft: 4,
            }}
          >
            <Translate value={label.subText} />
            &nbsp;
          </Element>
        )}
      </>
    )
  }

  return (
    <>
      <Translate value={label} />
      &nbsp;
    </>
  )
}
